module.exports = __webpack_public_path__ + "img/Realisme_Tida_og_samfunnsforholdene2.c77eaf08.jpg";